import React, { useState, useEffect, useRef } from "react";
import { Menu, message, Popconfirm } from "antd";
import "./sidebar.scss";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "./SidebarData";
import { useAuth } from "../../authentication/authHelpers";
import { FlexIconLogo, LogoKryesore, UserSidebar } from "../../assets/icons";
import { useNavigate, Outlet } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import {
  ChristmasFlexLogo,
  FlexHalloweenLogo,
  PinkRibbonFlexLogo,
} from "../../assets/holidays/icons";
import {
  Eagle,
  EagleAndLogo,
  RedAndBlackLogo,
  DarkRedAndBlackLogo,
} from "../../assets/holidays/icons";
import { useMediaQuery } from "react-responsive";
import dayjsTZ from "../../utils/dayjs";

const animationDuration = 12000;

function Sidebar({ data, collapsed }) {
  const auth = useAuth();
  const loc = useLocation();
  const navigate = useNavigate();

  const { users, isDarkMode } = useSelector((state) => state.usersList);

  const [k, setK] = useState([]);
  const [sData, setSData] = useState([]);
  const [pagatFocus, setPagatFocus] = useState(null);

  // const eagleRef = useRef(null);
  // const [hideLogo, setHideLogo] = useState(true);

  const handlePassword = () => {
    Swal.fire({
      title: "Vendos kodin personal!!",
      input: "password",
      inputAttributes: {
        autocapitalize: "off",
      },
      customClass: {
        popup: isDarkMode ? "custom-swal-dark" : "custom-swal",
      },
      showCancelButton: true,
      cancelButtonText: "Anulo",
      confirmButtonText: "Konfirmo",
      cancelButtonColor: "#ea3943",
      confirmButtonColor: "#1da193",
      reverseButtons: true,
      showLoaderOnConfirm: true,
      showClass: {
        popup: "",
      },
      hideClass: {
        popup: "", // disable popup fade-out animation
      },
      // preConfirm: async (login) => {
      // 	if (login === "1234") {
      // 		navigate("/pagat");
      // 	} else {
      // 		message.error("Kodi i vendosur eshte gabim!");
      // 	}
      // },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value === users?.pinNumber) {
          // Swal.fire({
          // 	title: `SAKTE!`,
          // });
          navigate("/pagat");
        } else {
          message.error("Kodi i vendosur eshte gabim!");
          handlePassword();
        }
      }
    });
  };

  // if refresh page to still be focused last item was clicked
  useEffect(() => {
    let pathname = loc.pathname;
    if (pathname.includes("specifikat"))
      pathname = pathname.split("/").slice(0, -1).join("/");

    let idx = SidebarData.findIndex((el) => el.to.includes(pathname));
    if (idx !== -1) setK([`${SidebarData[idx]?.key}`]);

    if (loc?.pathname === "/pagat" || loc?.pathname === "/pagat/llogaritja") {
      setPagatFocus("pagat");
    } else {
      setPagatFocus(null);
    }
  }, [loc]);

  useEffect(() => {
    if (data.length > 0) {
      setSData(data);
    }
  }, [data]);

  // useEffect(() => {
  //   const eagle = eagleRef.current;
  //   if (!eagle) return;

  //   const startTime = dayjsTZ().valueOf();
  //   let logoShown = false;

  //   const checkProgress = () => {
  //     const elapsedTime = dayjsTZ().valueOf() - startTime;
  //     const progress = (elapsedTime / animationDuration) * 100;

  //     // Show logo when eagle reaches the drop position (25% of animation)
  //     if (progress >= 25 && !logoShown) {
  //       setHideLogo(false);
  //       logoShown = true;
  //     }

  //     // Hide eagle when animation completes
  //     if (progress >= 100) {
  //       eagle.style.display = "none";
  //       return; // Stop further checks
  //     }

  //     if (elapsedTime < animationDuration) {
  //       requestAnimationFrame(checkProgress);
  //     }
  //   };

  //   requestAnimationFrame(checkProgress);

  //   return () => {
  //     setHideLogo(true);
  //   };
  // }, [animationDuration]);

  const isMobileView = useMediaQuery({
    query: "(max-width: 450px)",
  });

  // const RedAndBlackLogoThemed = isDarkMode
  //   ? DarkRedAndBlackLogo
  //   : RedAndBlackLogo;

  return (
    <div className={`side-bar ${isDarkMode ? "dark" : ""}`}>
      {!isMobileView ? (
        <Link to="/kryefaqja">
          <div className="sidebar-logo">
            {collapsed ? <FlexIconLogo /> : <LogoKryesore />}
            {/* {collapsed ? <FlexIconLogo /> : <PinkRibbonFlexLogo />} */}
            {/* {collapsed ? <FlexIconLogo /> : <FlexHalloweenLogo />} */}
            {/* {collapsed ? <FlexIconLogo /> : <ChristmasFlexLogo />} */}
          </div>
        </Link>
      ) : // <Link to="/kryefaqja">
      //   <div className="sidebar-logo">
      //     {!hideLogo ? <RedAndBlackLogoThemed /> : null}
      //   </div>
      //   <div className="sidebar-holidayLogo" ref={eagleRef}>
      //     <Eagle />
      //     {hideLogo ? <RedAndBlackLogoThemed /> : null}
      //   </div>
      // </Link>
      null}
      {sData?.length > 0 && (
        <Menu
          mode="inline"
          selectedKeys={k}
          defaultSelectedKeys={[k]}
          overlayClassName="main-sidebar"
          className="main-sidebar"
        >
          {/* <h1>{sData?.email}</h1> */}
          {/* fetch the sidebar data and check if have userAccess */}
          {(Array.isArray(data[0]?.accessConfig?.sidebarConfig[0])
            ? data[0]?.accessConfig?.sidebarConfig[0]
            : data[0]?.accessConfig?.sidebarConfig
          )
            ?.filter((a) => a.auth !== false)
            // A stored entry whose `to` has no icon in SidebarData would render
            // <undefined /> and take the whole app down, so it is dropped.
            ?.filter((a) => !!SidebarData.find((s) => s.to === a?.to)?.src)
            .map((el, idx) => {
              let Icon = SidebarData.find((s) => s.to === el.to)?.src;
              if (el?.to === "/pagat") {
                return (
                  <Popconfirm
                    classNames={{
                      root: `globalPopover ${isDarkMode ? "dark" : ""}`,
                    }}
                    className="sigurt"
                    placement="right"
                    title="A jeni te sigurt?"
                    onConfirm={() => handlePassword()}
                    key={el?.id}
                  >
                    <Menu.Item
                      className={pagatFocus === "pagat" ? "Focus-Show" : ""}
                      key={el?.id}
                      icon={
                        <span className="iconWrapper">
                          <Icon width={22} height={20} />
                        </span>
                      }
                      style={{
                        display: "flex",
                        flexDirection: `${!!collapsed ? "column" : "row"}`,
                      }}
                    >
                      {!collapsed && el?.title}
                    </Menu.Item>
                  </Popconfirm>
                );
              }
              return (
                <Menu.Item
                  key={el?.id}
                  icon={
                    <span className="iconWrapper">
                      <Icon width={18} height={16} />
                    </span>
                  }
                  title={el?.title}
                  style={{
                    display: "flex",
                    flexDirection: `${!!collapsed ? "column" : "row"}`,
                  }}
                >
                  <Link to={el?.to} key={el?.id} rel="noopener noreferrer">
                    {!collapsed && el?.title}
                  </Link>
                </Menu.Item>
              );
            })}{" "}
          {/* <img
						src="https://i.ibb.co/dQYXHpr/CITYPNG-COM-Sparkle-Lighted-Christmas-Deer-Illustration-PNG-2000x2000.png"
						width="250px"
					/> */}
        </Menu>
      )}{" "}
      {/* <div
				style={{
					marginTop: "200px",
				}}
			>
				<img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/25839/critters.svg" width="250px" />{" "}
				<br />
				<img
					src="https://i.ibb.co/dQYXHpr/CITYPNG-COM-Sparkle-Lighted-Christmas-Deer-Illustration-PNG-2000x2000.png"
					width="250px"
				/>
			</div> */}
    </div>
  );
}

export default Sidebar;
